import { ApiPath } from 'src/enums/apiPath';
import { apiRequest } from 'src/utils/api';

export const getPositionById = (id: string) => {
  return apiRequest.get({
    url: ApiPath.ADMIN_POSITIONS + `/${id}`
  });
};
